import React, { FunctionComponent, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  ModalBackdrop,
  ModalWrapper,
  Title,
  TitleText,
  CloseButton,
  Body,
  ParagraphsWrapper,
  Paragraph,
  LinkToReviews,
} from "./styles/modal-styles";

export interface IPendingReviewsDashboardModalProps {
  pendingReviewsCount?: number;
  showReviewModal?: boolean;
}
declare global {
  interface Window {
    __shouldShowReviewModal__?: boolean;
  }
}

const PendingReviewsDashboardModal: FunctionComponent<
  IPendingReviewsDashboardModalProps
> = ({ pendingReviewsCount, showReviewModal }) => {
  const [modalActive, setModalActive] = useState(false);
  const handleCloseButton = () => setModalActive(!modalActive);
  const [countdown, setCountdown] = useState(10); 
  const [canClose, setCanClose] = useState(false);

  useEffect(() => {
    if (showReviewModal && window.__shouldShowReviewModal__) {
      setModalActive(true);
      window.__shouldShowReviewModal__ = false;
    }
    const handleModalTrigger = () => {
      if (showReviewModal) {
        setModalActive(true);
        setCountdown(10);
        setCanClose(false);
      }
    };

    window.addEventListener(
      "postModalClosedCheckReviewModal",
      handleModalTrigger
    );

    return () => {
      window.removeEventListener(
        "postModalClosedCheckReviewModal",
        handleModalTrigger
      );
    };
  }, [showReviewModal]);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (modalActive && countdown > 0) {
      timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    } else if (modalActive && countdown === 0) {
      setCanClose(true);
    }
    return () => clearTimeout(timer);
  }, [modalActive, countdown]);

  if (modalActive) {
    return (
      <ModalBackdrop>
        <ModalWrapper data-test-id="pending-reviews-dashboard-modal">
          <Title>
            <TitleText>
              Great news — you've made successful placements through our valued
              agency partners.
            </TitleText>
            {canClose ? (
              <CloseButton
                onClick={handleCloseButton}
                data-test-id="close-pending-reviews-dashboard-modal-button"
              >
                <FontAwesomeIcon icon={faTimes} />
              </CloseButton>
            ) : (
              <span style={{ fontSize: "14px", color: "#888" }}>
                {countdown}s
              </span>
            )}
          </Title>
          <Body>
            <ParagraphsWrapper>
              <Paragraph>
                Please take a moment to review the agencies you've worked with. Your feedback helps other employers choose wisely and directly affects your HH rating              </Paragraph>
              <Paragraph>
                If you don't leave a review within <strong>14 days,</strong> a <strong>5-star rating</strong> will be added automatically.
              </Paragraph>
              <Paragraph>
                Thank you — your input keeps our marketplace fair, high-quality, and successful for everyone.
              </Paragraph>
              <Paragraph center>
                You have{" "}
                <strong>
                  {" "}
                  {pendingReviewsCount}{" "}
                  {pendingReviewsCount === 1 ? "review" : "reviews"}
                </strong>{" "}
                outstanding.
              </Paragraph>
              <Paragraph center>
                Click{" "}
                <LinkToReviews href="/employer/pending_reviews#/">
                  here
                </LinkToReviews>{" "}
                to leave a review.
              </Paragraph>
            </ParagraphsWrapper>
          </Body>
        </ModalWrapper>
      </ModalBackdrop>
    );
  }
  return null;
};

PendingReviewsDashboardModal.propTypes = {
  pendingReviewsCount: PropTypes.number,
  showReviewModal: PropTypes.bool,
};

PendingReviewsDashboardModal.defaultProps = {
  pendingReviewsCount: null,
  showReviewModal: false,
};

export default PendingReviewsDashboardModal;
